<template>
<div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon mr-auto text-nowrap d-none d-md-block"
      @click="openNewReservationPage()"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Nieuwe Reservering
    </button>
</div>
</template>
<script>
    export default {
        methods: {
            openNewReservationPage(){
                this.$store.commit('reservation/reset')
                this.$router.push({ name: 'newReservation' })
            }
        }
    }
</script>